var map = {
	"./cs": 962,
	"./cs.js": 962,
	"./de": 964,
	"./de-at": 963,
	"./de-at.js": 963,
	"./de.js": 964,
	"./en-au": 965,
	"./en-au.js": 965,
	"./en-ca": 966,
	"./en-ca.js": 966,
	"./en-gb": 967,
	"./en-gb.js": 967,
	"./en-ie": 968,
	"./en-ie.js": 968,
	"./en-nz": 969,
	"./en-nz.js": 969,
	"./es": 971,
	"./es-do": 970,
	"./es-do.js": 970,
	"./es.js": 971,
	"./it": 972,
	"./it.js": 972,
	"./pl": 973,
	"./pl.js": 973,
	"./ru": 974,
	"./ru.js": 974
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2127;


//////////////////
// WEBPACK FOOTER
// ./~/moment/locale pl|en|cs|de|es|ru|it
// module id = 2127
// module chunks = 1